import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=805ec9a6&"
import script from "./Diagnosis.vue?vue&type=script&lang=ts&"
export * from "./Diagnosis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805ec9a6')) {
      api.createRecord('805ec9a6', component.options)
    } else {
      api.reload('805ec9a6', component.options)
    }
    module.hot.accept("./Diagnosis.vue?vue&type=template&id=805ec9a6&", function () {
      api.rerender('805ec9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/Diagnosis.vue"
export default component.exports